import RecipientStatusPills from './RecipientStatusPills';
import EnvelopeActions from './EnvelopeActions';

const ENVELOPE_STATUS_STYLE = {
  draft: 'bg-gray-100 text-gray-700',
  sent: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
  voided: 'bg-red-100 text-red-700',
  expired: 'bg-amber-100 text-amber-700',
  declined: 'bg-red-100 text-red-700',
};

function formatRelative(iso) {
  if (!iso) return '—';
  const d = iso instanceof Date ? iso : new Date(iso);
  const diff = Date.now() - d.getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function EnvelopeRow({ envelope, onClick, onAction }) {
  return (
    <tr
      className="border-b border-gray-100 last:border-0 hover:bg-gray-50 cursor-pointer transition"
      onClick={onClick}
    >
      <td className="px-4 py-3 max-w-xs">
        <div className="font-medium text-gray-900 truncate">{envelope.subject || 'Untitled'}</div>
        {envelope.original_filename && envelope.original_filename !== envelope.subject && (
          <div className="text-xs text-gray-500 truncate">{envelope.original_filename}</div>
        )}
      </td>
      <td className="px-4 py-3">
        <RecipientStatusPills recipients={envelope.recipients} />
      </td>
      <td className="px-4 py-3 text-sm text-gray-500">
        {formatRelative(envelope.last_activity_at || envelope.updated_at)}
      </td>
      <td className="px-4 py-3">
        <span
          className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            ENVELOPE_STATUS_STYLE[envelope.status] || 'bg-gray-100 text-gray-700'
          }`}
        >
          {envelope.status}
        </span>
      </td>
      <td className="px-4 py-3 text-right">
        <EnvelopeActions envelope={envelope} onAction={onAction} />
      </td>
    </tr>
  );
}
